/* 意向单表单：把定制游页的静态 TmForm 变成真表单。
 * 由 nav.js 在 dingzhi 路由注入后调用 window.LN_INQUIRY.enhance(root, lang)。
 * 提交目标见下方 CONFIG —— 接你自己的后端时只改 CONFIG（ENDPOINT / mapPayload / auth）。*/
window.LN_INQUIRY = (function () {
  'use strict';

  /* ============================ 配置区（接后端只改这里）============================ */
  var CONFIG = {
    // 你后端的接收地址。留空('')时表单进入“降级模式”：不 POST，改为打开 WhatsApp 带上填好的内容，
    // 同时把 payload 打到 console，方便你先测 UI。拿到接口后把 URL 填进来即可上线。
    ENDPOINT: '',
    METHOD: 'POST',
    // 发送格式：'json' -> application/json ; 'form' -> application/x-www-form-urlencoded
    FORMAT: 'json',
    // 额外请求头（如需 Authorization，注意：密钥不要放前端！用 Cloudflare Worker 代理，见对话说明）
    HEADERS: {},
    // 把内部规范 payload 映射成你后端期望的字段名。默认原样发送。
    // 例：return { customer_name: p.name, contact_email: p.email, note: p.message, ... };
    mapPayload: function (p) { return p; },
    // 判定成功：默认 HTTP 2xx 即成功。可改成检查返回体，如 r => r.ok && (await r.json()).code===0
    isSuccess: function (res) { return res && res.ok; },
    // 防垃圾：填 Cloudflare Turnstile 的 site key（公开可放前端）后自动启用；留空则不加。
    TURNSTILE_SITE_KEY: '',
    WA: '8613316423196',
    WECHAT_ID: 'LingnanJourneys'
  };

  /* ============================ 四语文案 ============================ */
  var T = {
    cn: { req: '请填写', badEmail: '邮箱格式不正确', sending: '提交中…',
      okTitle: '已收到您的意向 ✓', okBody: '感谢！我们的规划师会在 24 小时内通过邮箱或 WhatsApp 与您联系。',
      err: '提交失败,请重试,或点下方 WhatsApp 直接联系我们。', name: '姓名', email: '邮箱' },
    en: { req: 'Please fill in', badEmail: 'Please enter a valid email', sending: 'Sending…',
      okTitle: 'Request received ✓', okBody: 'Thank you! Your travel designer will reach out within 24 hours by email or WhatsApp.',
      err: 'Something went wrong. Please try again, or tap WhatsApp below to reach us directly.', name: 'name', email: 'email' },
    ja: { req: 'ご入力ください', badEmail: '有効なメールアドレスを入力してください', sending: '送信中…',
      okTitle: 'リクエストを受け付けました ✓', okBody: 'ありがとうございます。担当プランナーが24時間以内にメールまたはWhatsAppでご連絡します。',
      err: '送信に失敗しました。もう一度お試しいただくか、下のWhatsAppからご連絡ください。', name: 'お名前', email: 'メール' },
    ko: { req: '입력해 주세요', badEmail: '올바른 이메일을 입력해 주세요', sending: '전송 중…',
      okTitle: '요청이 접수되었습니다 ✓', okBody: '감사합니다! 담당 플래너가 24시간 이내에 이메일 또는 WhatsApp으로 연락드립니다.',
      err: '전송에 실패했습니다. 다시 시도하거나 아래 WhatsApp으로 연락 주세요.', name: '이름', email: '이메일' }
  };

  /* ============================ 归因 / UTM 采集（落地即存,提交时带上）============================ */
  function captureAttribution() {
    try {
      var KEY = 'ln_attr';
      var stored = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (stored) return stored;
      var q = new URLSearchParams(location.search);
      var attr = {
        utm_source: q.get('utm_source') || '', utm_medium: q.get('utm_medium') || '',
        utm_campaign: q.get('utm_campaign') || '', utm_term: q.get('utm_term') || '',
        utm_content: q.get('utm_content') || '', gclid: q.get('gclid') || '', fbclid: q.get('fbclid') || '',
        referrer: document.referrer || '', landing_page: location.href
      };
      sessionStorage.setItem(KEY, JSON.stringify(attr));
      return attr;
    } catch (e) { return { landing_page: location.href, referrer: document.referrer || '' }; }
  }

  /* ============================ 工具 ============================ */
  function suffix(el, pre) { return (el.getAttribute('data-pencil-name') || '').slice(pre.length); }
  function decode(s) { var d = document.createElement('textarea'); d.innerHTML = s; return d.value; }

  // 把一个 “字段容器” 变成真输入框；返回 input 元素
  function inject(container, phPrefix, key, opts) {
    opts = opts || {};
    var ph = container.querySelector('[data-pencil-name^="' + phPrefix + '"]');
    var placeholder = ph ? ph.textContent.trim() : '';
    if (ph) ph.style.display = 'none';
    var tag = opts.textarea ? 'textarea' : 'input';
    var input = document.createElement(tag);
    if (!opts.textarea) input.type = opts.type || 'text';
    input.placeholder = placeholder;
    input.setAttribute('data-inq', key);
    if (opts.required) input.required = true;
    input.style.cssText = 'width:100%;border:0;background:transparent;outline:0;font:inherit;color:#231F1D;' +
      (opts.textarea ? 'min-height:64px;resize:vertical;line-height:1.6;' : '');
    // 让容器可点整块聚焦
    container.style.cursor = 'text';
    container.appendChild(input);
    return input;
  }

  /* —— 真实产品映射:从线路页进入定制页时,自动带出线路名/天数/目的地 —— */
  var PRODUCTS = {
    liting:   { cn: '漓境纯美 · 桂林阳朔 4 日', en: 'Pure Li · Guilin & Yangshuo 4-Day', daysCn: '4 天', daysEn: '4 days', dest: 'Guangxi' },
    guilong:  { cn: '桂龙山水记 · 桂林 5 日', en: 'Guilong · Longji & Li River 5-Day', daysCn: '5 天', daysEn: '5 days', dest: 'Guangxi' },
    liyu:     { cn: '漓遇阳朔 · 4天3晚高端臻享', en: 'Liyu Yangshuo · 4-Day Premium', daysCn: '4 天 3 晚', daysEn: '4 days / 3 nights', dest: 'Guangxi' },
    jinpin:   { cn: '金品桂林 · 4 日全景', en: 'Golden Guilin · 4-Day Panorama', daysCn: '4 天', daysEn: '4 days', dest: 'Guangxi' },
    yangcheng:{ cn: '羊城风华 · 广州 3 天 2 晚', en: 'Canton Charm · Guangzhou 3-Day', daysCn: '3 天 2 晚', daysEn: '3 days / 2 nights', dest: 'Guangzhou & Foshan' },
    gftour:   { cn: '广佛寻迹 · 4 天 3 晚', en: 'Guangzhou & Foshan Trail · 4-Day', daysCn: '4 天 3 晚', daysEn: '4 days / 3 nights', dest: 'Guangzhou & Foshan' },
    sc7d:     { cn: '华南联游 · 7 天 6 晚', en: 'South China · 7 Days 6 Nights', daysCn: '7 天 6 晚', daysEn: '7 days / 6 nights', dest: 'Both' }
  };
  function intentKey() { try { return sessionStorage.getItem('ln_intent_route') || ''; } catch (e) { return ''; } }
  function intentProduct() { return PRODUCTS[intentKey()] || null; }
  function intentName(lang) { var p = intentProduct(); return p ? (lang === 'cn' ? p.cn : p.en) : ''; }
  // 由 nav.js 在每次进入 #dingzhi 后调用;桌面(TmForm)与移动([data-ln-mform])通吃
  function applyIntent(scope, lang) {
    var p = intentProduct(); if (!p || !scope) return;
    var isCn = (lang === 'cn');
    var root = scope.querySelector('[data-pencil-name="TmForm"]') || scope.querySelector('[data-ln-mform]');
    if (!root || root.__lnIntent === intentKey()) return;
    root.__lnIntent = intentKey();
    var name = isCn ? p.cn : p.en;
    var len = root.querySelector('[data-inq="trip_length"]'); if (len && !len.value) len.value = isCn ? p.daysCn : p.daysEn;
    var msg = root.querySelector('[data-inq="message"]');
    if (msg && !msg.value) msg.value = isCn ? ('我对「' + name + '」感兴趣,请按这条线路为我定制。') : ('I\'m interested in "' + name + '" — please tailor from this tour.');
    var chip = root.querySelector('[data-pencil-name="DestChip-' + p.dest + '"]');   // 桌面 chip
    if (chip && !chip.style.outline) chip.click();
    var mchip = root.querySelector('[data-chip="dest"][data-val="' + p.dest + '"]'); // 移动 chip
    if (mchip && mchip.style.background !== 'rgb(176, 23, 34)') mchip.click();
  }

  function enhance(scope, lang) {
    var root = scope.querySelector('[data-pencil-name="TmForm"]');
    if (!root || root.__lnInquiry) return;      // 只在定制游页、且只增强一次
    root.__lnInquiry = true;
    var t = T[lang] || T.en;
    var attr = captureAttribution();
    var state = { dest: '', interests: {} };

    // —— 文本字段（三行,按文档顺序映射规范 key）——
    var row1 = root.querySelectorAll('[data-pencil-name^="FGField-"]');
    var k1 = ['travel_dates', 'trip_length', 'travelers'];
    row1.forEach(function (c, i) { inject(c, 'FGPh-', k1[i] || ('f1_' + i), i === 0 ? { type: 'date' } : {}); });   // 出发日期=原生日期选择器

    var row2 = root.querySelectorAll('[data-pencil-name^="FG2Field-"]');
    var k2 = ['hotel_style', 'budget'];
    row2.forEach(function (c, i) { inject(c, 'FG2Ph-', k2[i] || ('f2_' + i)); });

    var row3 = root.querySelectorAll('[data-pencil-name^="FG3Field-"]');
    var k3 = [{ k: 'name', req: 1 }, { k: 'email', req: 1, type: 'email' }, { k: 'contact' }];
    row3.forEach(function (c, i) {
      var m = k3[i] || { k: 'f3_' + i };
      inject(c, 'FG3Ph-', m.k, { required: m.req, type: m.type });
    });

    var ta = root.querySelector('[data-pencil-name="FormTextarea"]');
    if (ta) inject(ta, 'FormTaPh', 'message', { textarea: true });

    // —— 真实产品数据占位 + 日期下限=今天(设计稿占位是示意文案,这里换成真实档位)——
    var PH = (lang === 'cn')
      ? { trip_length: '如 4–7 天(我们的线路 3–7 天)', travelers: '如 2 位成人 · 1 位儿童', hotel_style: '如 国际连锁(万枫/曼悦档)或特色民宿', budget: '如 ¥1,900–4,500/人(不含机票)' }
      : { trip_length: 'e.g. 4–7 days (our tours run 3–7)', travelers: 'e.g. 2 adults · 1 child', hotel_style: 'e.g. Fairfield/Manyue tier, or boutique stays', budget: 'e.g. $270–650 pp (excl. flights)' };
    Object.keys(PH).forEach(function (k) { var i = root.querySelector('[data-inq="' + k + '"]'); if (i) i.placeholder = PH[k]; });
    var dtIn = root.querySelector('[data-inq="travel_dates"]');
    if (dtIn) { try { dtIn.min = new Date().toISOString().slice(0, 10); } catch (e) {} }

    // —— chips ——
    function styleChip(el, on) {
      el.style.transition = 'all .15s';
      el.style.outline = on ? '2px solid #B01722' : '';
      el.style.outlineOffset = on ? '-1px' : '';
      el.style.background = on ? '#FDECEC' : '';
      var chk = el.querySelector('[data-pencil-name^="DestChipCheck-"]');
      if (chk) chk.style.display = on ? '' : 'none';
    }
    var destChips = root.querySelectorAll('[data-pencil-name^="DestChip-"]');
    destChips.forEach(function (el) {
      if (/^DestChip(Check|Text)-/.test(el.getAttribute('data-pencil-name') || '')) return;
      el.style.cursor = 'pointer'; styleChip(el, false);
      el.addEventListener('click', function () {
        var v = decode(suffix(el, 'DestChip-'));
        state.dest = (state.dest === v) ? '' : v;
        destChips.forEach(function (o) {
          if (/^DestChip(Check|Text)-/.test(o.getAttribute('data-pencil-name') || '')) return;
          styleChip(o, decode(suffix(o, 'DestChip-')) === state.dest);
        });
      });
    });
    var intChips = root.querySelectorAll('[data-pencil-name^="IntChip-"]');
    intChips.forEach(function (el) {
      if (/^IntChip(Text)-/.test(el.getAttribute('data-pencil-name') || '')) return;
      el.style.cursor = 'pointer';
      el.addEventListener('click', function () {
        var v = decode(suffix(el, 'IntChip-'));
        if (state.interests[v]) { delete state.interests[v]; styleChip(el, false); }
        else { state.interests[v] = 1; styleChip(el, true); }
      });
    });

    // —— 状态提示条 ——
    var submitRow = root.querySelector('[data-pencil-name="FormSubmitRow"]') ||
                    root.querySelector('[data-pencil-name="FormSubmit"]');
    var status = document.createElement('div');
    status.style.cssText = 'font:600 13px/1.6 system-ui,-apple-system,sans-serif;margin-top:12px;display:none';
    if (submitRow && submitRow.parentNode) submitRow.parentNode.insertBefore(status, submitRow.nextSibling);
    function setStatus(msg, color) { status.textContent = msg; status.style.color = color || '#B01722'; status.style.display = msg ? '' : 'none'; }

    function val(key) { var i = root.querySelector('[data-inq="' + key + '"]'); return i ? i.value.trim() : ''; }
    function collect() {
      return {
        destination: state.dest, tour: intentName(lang === 'cn' ? 'cn' : 'en'),
        travel_dates: val('travel_dates'), trip_length: val('trip_length'), travelers: val('travelers'),
        interests: Object.keys(state.interests), hotel_style: val('hotel_style'), budget: val('budget'),
        message: val('message'), name: val('name'), email: val('email'), contact: val('contact'),
        lang: lang, page_url: location.href, submitted_at: new Date().toISOString(),
        utm_source: attr.utm_source, utm_medium: attr.utm_medium, utm_campaign: attr.utm_campaign,
        utm_term: attr.utm_term, utm_content: attr.utm_content, gclid: attr.gclid, fbclid: attr.fbclid,
        referrer: attr.referrer, landing_page: attr.landing_page
      };
    }
    function waSummary(p) {
      var L = [];
      if (p.tour) L.push('意向线路/Tour: ' + p.tour);
      if (p.destination) L.push('目的地/Destination: ' + p.destination);
      if (p.travel_dates) L.push('日期/Dates: ' + p.travel_dates);
      if (p.trip_length) L.push('天数/Length: ' + p.trip_length);
      if (p.travelers) L.push('人数/Travelers: ' + p.travelers);
      if (p.interests.length) L.push('兴趣/Interests: ' + p.interests.join(', '));
      if (p.hotel_style) L.push('酒店/Hotel: ' + p.hotel_style);
      if (p.budget) L.push('预算/Budget: ' + p.budget);
      if (p.name) L.push('姓名/Name: ' + p.name);
      if (p.email) L.push('邮箱/Email: ' + p.email);
      if (p.contact) L.push('联系/Contact: ' + p.contact);
      if (p.message) L.push('留言/Message: ' + p.message);
      return '你好，岭南漫游！我想定制行程:\n' + L.join('\n');
    }

    // —— 提交 ——
    var submitBtn = root.querySelector('[data-pencil-name="FormSubmit"]');
    var submitText = root.querySelector('[data-pencil-name="FormSubmitText"]');
    var busy = false;
    function submit() {
      if (busy) return;
      setStatus('', '#B01722');
      var p = collect();
      if (!p.name) { setStatus(t.req + ' ' + t.name, '#B01722'); return; }
      if (!p.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.email)) { setStatus(t.badEmail, '#B01722'); return; }

      // 降级模式：没配后端 -> 打开 WhatsApp 带上内容,不丢线索
      if (!CONFIG.ENDPOINT) {
        try { console.log('[LN_INQUIRY] payload (no ENDPOINT set):', CONFIG.mapPayload(p)); } catch (e) {}
        window.open('https://wa.me/' + CONFIG.WA + '?text=' + encodeURIComponent(waSummary(p)), '_blank', 'noopener');
        showSuccess();
        return;
      }

      busy = true;
      var origText = submitText ? submitText.textContent : '';
      if (submitText) submitText.textContent = t.sending;
      var body, headers = Object.assign({}, CONFIG.HEADERS);
      var mapped = CONFIG.mapPayload(p);
      if (CONFIG.FORMAT === 'form') {
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        body = new URLSearchParams(flatten(mapped)).toString();
      } else {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify(mapped);
      }
      fetch(CONFIG.ENDPOINT, { method: CONFIG.METHOD, headers: headers, body: body })
        .then(function (res) {
          if (CONFIG.isSuccess(res)) { showSuccess(); }
          else { throw new Error('bad status ' + (res && res.status)); }
        })
        .catch(function (err) {
          busy = false;
          if (submitText) submitText.textContent = origText;
          setStatus(t.err, '#B01722');
          try { console.warn('[LN_INQUIRY] submit failed:', err); } catch (e) {}
        });
    }
    function flatten(o) { var r = {}; Object.keys(o).forEach(function (k) { r[k] = Array.isArray(o[k]) ? o[k].join(',') : o[k]; }); return r; }

    function showSuccess() {
      var card = document.createElement('div');
      card.style.cssText = 'background:#F2F8F4;border:1px solid #BFDFCB;border-radius:16px;padding:28px 30px;margin-top:8px';
      card.innerHTML = '<div style="font:700 20px/1.3 \'Playfair Display\',Georgia,serif;color:#2E6E64">' + t.okTitle + '</div>' +
        '<div style="font:400 14px/1.7 system-ui,-apple-system,sans-serif;color:#4A423D;margin-top:8px">' + t.okBody + '</div>';
      root.parentNode.insertBefore(card, root);
      root.style.display = 'none';
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    if (submitBtn) {
      submitBtn.style.cursor = 'pointer';
      submitBtn.addEventListener('click', function (e) { e.preventDefault(); submit(); });
    }
    // 回车提交（在文本 input 内）
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.tagName === 'INPUT') { e.preventDefault(); submit(); }
    });

    // —— “更想直接聊?” WhatsApp 备用按钮 ——
    var waBtn = root.querySelector('[data-pencil-name="FormAltBtn-WhatsApp"]');
    if (waBtn) {
      waBtn.style.cursor = 'pointer';
      waBtn.addEventListener('click', function () {
        window.open('https://wa.me/' + CONFIG.WA + '?text=' + encodeURIComponent(waSummary(collect())), '_blank', 'noopener');
      });
    }
    var wcBtn = root.querySelector('[data-pencil-name="FormAltBtn-WeChat"]');
    if (wcBtn) {
      wcBtn.style.cursor = 'pointer';
      wcBtn.addEventListener('click', function () {
        setStatus('WeChat: ' + CONFIG.WECHAT_ID, '#2E6E64');
        try { navigator.clipboard && navigator.clipboard.writeText(CONFIG.WECHAT_ID); } catch (e) {}
      });
    }
  }

  /* ============================ 移动端定制表单(#dingzhi 手机版,复用同一 CONFIG 提交) ============================ */
  var SANS = "system-ui,-apple-system,'Segoe UI','PingFang SC','Hiragino Sans','Apple SD Gothic Neo',sans-serif";
  var SERF = "'Playfair Display',Georgia,serif";
  var MFORM = {
    cn: {
      eyebrow: '免费定制', title: '定制你的专属行程', sub: '告诉我们你的偏好,规划师将在 24 小时内联系你——满意前不付款。',
      s1: '目的地与时间', destLabel: '想去哪里?',
      dest: [['广西', 'Guangxi'], ['广州 · 佛山', 'Guangzhou & Foshan'], ['两地都去', 'Both'], ['还没定', 'Not sure yet']],
      dates: '出发日期', datesPh: '', len: '行程天数', lenPh: '如 4–7 天(我们的线路 3–7 天)', pax: '人数', paxPh: '如 2 位成人 · 1 位儿童',
      s2: '旅行风格', intLabel: '什么最打动你?(可多选)',
      interests: [['📷 摄影', '📷 Photography'], ['🍜 美食', '🍜 Food & markets'], ['👨‍👩‍👧 亲子', '👨‍👩‍👧 Family'], ['🏞 徒步', '🏞 Hiking'], ['🏮 文化历史', '🏮 Culture & history'], ['🐼 慢节奏', '🐼 Slow & easy']],
      hotel: '酒店风格', hotelPh: '如 国际连锁(万枫/曼悦档)或特色民宿', budget: '每人预算', budgetPh: '如 ¥1,900–4,500/人(不含机票)',
      s3: '留言与联系方式', msg: '其他需求(选填)', msgPh: '行动不便、饮食禁忌、特殊场合…', name: '你的姓名', namePh: '如 张先生', email: '邮箱', emailPh: 'you@example.com', contact: 'WhatsApp / 微信(选填)', contactPh: '+86 …',
      submit: '提交定制申请 — 免费', fine: '提交即代表同意我们的隐私政策。'
    },
    en: {
      eyebrow: 'FREE & TAILOR-MADE', title: 'Design your private journey', sub: "Tell us what you love — your designer replies within 24 hours. No payment until you love the plan.",
      s1: 'Where & when', destLabel: 'Where to?',
      dest: [['Guangxi', 'Guangxi'], ['Guangzhou & Foshan', 'Guangzhou & Foshan'], ['Both', 'Both'], ['Not sure yet', 'Not sure yet']],
      dates: 'Departure date', datesPh: '', len: 'Trip length', lenPh: 'e.g. 4–7 days (our tours run 3–7)', pax: 'Travelers', paxPh: 'e.g. 2 adults · 1 child',
      s2: 'Your travel style', intLabel: 'What moves you? (pick any)',
      interests: [['📷 Photography', '📷 Photography'], ['🍜 Food & markets', '🍜 Food & markets'], ['👨‍👩‍👧 Family', '👨‍👩‍👧 Family'], ['🏞 Hiking', '🏞 Hiking'], ['🏮 Culture & history', '🏮 Culture & history'], ['🐼 Slow & easy', '🐼 Slow & easy']],
      hotel: 'Hotel style', hotelPh: 'e.g. Fairfield/Manyue tier, or boutique stays', budget: 'Budget per person', budgetPh: 'e.g. $270–650 pp (excl. flights)',
      s3: 'Tell us more & stay in touch', msg: 'Anything else? (optional)', msgPh: 'Mobility needs, food allergies, special occasion…', name: 'Your name', namePh: 'e.g. Alex Chen', email: 'Email', emailPh: 'you@example.com', contact: 'WhatsApp / WeChat (optional)', contactPh: '+1 …',
      submit: 'Send my request — it’s free', fine: 'By sending you agree to our privacy policy.'
    }
  };
  function mesc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function mStep(title, num) { return '<div style="display:flex;align-items:center;gap:10px;margin:24px 0 14px"><span style="font:700 22px/1 ' + SERF + ';color:#C9A86A">' + num + '</span><span style="font:700 17px/1.2 ' + SERF + ';color:#231F1D">' + mesc(title) + '</span></div>'; }
  function mLabel(t) { return '<div style="font:600 13px/1.4 ' + SANS + ';color:#231F1D;margin-bottom:8px">' + mesc(t) + '</div>'; }
  function mField(label, key, ph, o) {
    o = o || {};
    var tag = o.textarea ? 'textarea' : 'input';
    var ctrl = '<' + tag + ' data-inq="' + key + '"' + (o.type ? ' type="' + o.type + '"' : '') + ' placeholder="' + mesc(ph) + '" style="width:100%;box-sizing:border-box;border:1px solid #D9CFC2;border-radius:12px;padding:13px 14px;font:400 15px/1.4 ' + SANS + ';color:#231F1D;background:#fff;outline:none;' + (o.textarea ? 'min-height:92px;resize:vertical;line-height:1.6' : '') + '"></' + (o.textarea ? 'textarea' : 'input') + '>';
    return '<label style="display:block;margin-bottom:15px"><span style="display:block;font:600 13px/1.4 ' + SANS + ';color:#231F1D;margin-bottom:6px">' + mesc(label) + (o.req ? ' <span style="color:#B01722">*</span>' : '') + '</span>' + ctrl + '</label>';
  }
  function mChip(label, val, group) { return '<button type="button" data-chip="' + group + '" data-val="' + mesc(val) + '" style="font:600 13px/1 ' + SANS + ';color:#231F1D;background:#fff;border:1px solid #D9CFC2;border-radius:9999px;padding:10px 14px;cursor:pointer;transition:all .14s">' + mesc(label) + '</button>'; }

  function renderMobile(lang) {
    lang = (lang === 'cn' || lang === 'en') ? lang : 'en';
    var m = MFORM[lang];
    return '<section style="background:#fff;padding:34px 20px 6px">' +
        '<div style="font:700 11px/1.4 ' + SANS + ';letter-spacing:2px;color:#B01722">' + mesc(m.eyebrow) + '</div>' +
        '<h1 style="font:700 30px/1.2 ' + SERF + ';color:#231F1D;margin:10px 0 10px">' + mesc(m.title) + '</h1>' +
        '<p style="font:400 14px/1.7 ' + SANS + ';color:#6B625B;margin:0">' + mesc(m.sub) + '</p>' +
      '</section>' +
      '<form data-ln-mform style="background:#fff;padding:6px 20px 40px" onsubmit="return false">' +
        mStep(m.s1, '01') + mLabel(m.destLabel) +
        '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:16px">' + m.dest.map(function (d) { return mChip(d[0], d[1], 'dest'); }).join('') + '</div>' +
        mField(m.dates, 'travel_dates', m.datesPh, { type: 'date' }) + mField(m.len, 'trip_length', m.lenPh) + mField(m.pax, 'travelers', m.paxPh) +
        mStep(m.s2, '02') + mLabel(m.intLabel) +
        '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:16px">' + m.interests.map(function (d) { return mChip(d[0], d[1], 'interest'); }).join('') + '</div>' +
        mField(m.hotel, 'hotel_style', m.hotelPh) + mField(m.budget, 'budget', m.budgetPh) +
        mStep(m.s3, '03') +
        mField(m.msg, 'message', m.msgPh, { textarea: true }) +
        mField(m.name, 'name', m.namePh, { req: true }) + mField(m.email, 'email', m.emailPh, { req: true, type: 'email' }) + mField(m.contact, 'contact', m.contactPh) +
        '<div data-mstatus style="font:600 13px/1.6 ' + SANS + ';color:#B01722;margin:4px 0 12px;display:none"></div>' +
        '<button type="button" data-msubmit style="width:100%;background:#B01722;color:#fff;border:0;border-radius:9999px;padding:16px;font:700 16px/1 ' + SANS + ';cursor:pointer">' + mesc(m.submit) + '</button>' +
        '<a href="https://wa.me/' + CONFIG.WA + '" target="_blank" rel="noopener" style="display:block;text-align:center;margin-top:10px;background:transparent;border:1px solid #D9CFC2;color:#231F1D;border-radius:9999px;padding:14px;font:700 15px/1 ' + SANS + ';text-decoration:none">WhatsApp</a>' +
        '<p style="font:400 11px/1.5 ' + SANS + ';color:#9c928a;margin:14px 0 0;text-align:center">' + mesc(m.fine) + '</p>' +
      '</form>';
  }

  function mWaSummary(p) {
    var L = [];
    if (p.tour) L.push('意向线路/Tour: ' + p.tour);
    if (p.destination) L.push('目的地/Destination: ' + p.destination);
    if (p.travel_dates) L.push('日期/Dates: ' + p.travel_dates);
    if (p.trip_length) L.push('天数/Length: ' + p.trip_length);
    if (p.travelers) L.push('人数/Travelers: ' + p.travelers);
    if (p.interests.length) L.push('兴趣/Interests: ' + p.interests.join(', '));
    if (p.hotel_style) L.push('酒店/Hotel: ' + p.hotel_style);
    if (p.budget) L.push('预算/Budget: ' + p.budget);
    if (p.name) L.push('姓名/Name: ' + p.name);
    if (p.email) L.push('邮箱/Email: ' + p.email);
    if (p.contact) L.push('联系/Contact: ' + p.contact);
    if (p.message) L.push('留言/Message: ' + p.message);
    return '你好，岭南漫游！我想定制行程:\n' + L.join('\n');
  }
  function mFlatten(o) { var r = {}; Object.keys(o).forEach(function (k) { r[k] = Array.isArray(o[k]) ? o[k].join(',') : o[k]; }); return r; }
  function mSend(p) {
    if (!CONFIG.ENDPOINT) {
      try { console.log('[LN_INQUIRY] payload (no ENDPOINT set):', CONFIG.mapPayload(p)); } catch (e) {}
      window.open('https://wa.me/' + CONFIG.WA + '?text=' + encodeURIComponent(mWaSummary(p)), '_blank', 'noopener');
      return Promise.resolve('fallback');
    }
    var headers = Object.assign({}, CONFIG.HEADERS), body, mapped = CONFIG.mapPayload(p);
    if (CONFIG.FORMAT === 'form') { headers['Content-Type'] = 'application/x-www-form-urlencoded'; body = new URLSearchParams(mFlatten(mapped)).toString(); }
    else { headers['Content-Type'] = 'application/json'; body = JSON.stringify(mapped); }
    return fetch(CONFIG.ENDPOINT, { method: CONFIG.METHOD, headers: headers, body: body }).then(function (res) { if (CONFIG.isSuccess(res)) return 'success'; throw new Error('bad status'); });
  }

  function wireMobile(scope, lang) {
    lang = (lang === 'cn' || lang === 'en') ? lang : 'en';
    var form = scope.querySelector('[data-ln-mform]'); if (!form || form.__wired) return; form.__wired = true;
    var t = T[lang] || T.en, attr = captureAttribution(), state = { dest: '', interests: {} };
    var mdt = form.querySelector('[data-inq="travel_dates"]');
    if (mdt) { try { mdt.min = new Date().toISOString().slice(0, 10); } catch (e) {} }
    function styleChip(el, on) { el.style.background = on ? '#B01722' : '#fff'; el.style.color = on ? '#fff' : '#231F1D'; el.style.borderColor = on ? '#B01722' : '#D9CFC2'; }
    form.querySelectorAll('[data-chip]').forEach(function (c) {
      c.addEventListener('click', function () {
        var g = c.getAttribute('data-chip'), v = c.getAttribute('data-val');
        if (g === 'dest') { state.dest = (state.dest === v) ? '' : v; form.querySelectorAll('[data-chip="dest"]').forEach(function (o) { styleChip(o, o.getAttribute('data-val') === state.dest); }); }
        else { if (state.interests[v]) { delete state.interests[v]; styleChip(c, false); } else { state.interests[v] = 1; styleChip(c, true); } }
      });
    });
    var status = form.querySelector('[data-mstatus]'), btn = form.querySelector('[data-msubmit]'), busy = false;
    function setStatus(msg, c) { status.textContent = msg || ''; status.style.color = c || '#B01722'; status.style.display = msg ? '' : 'none'; }
    function val(k) { var i = form.querySelector('[data-inq="' + k + '"]'); return i ? i.value.trim() : ''; }
    btn.addEventListener('click', function () {
      if (busy) return; setStatus('');
      var p = {
        destination: state.dest, tour: intentName(lang === 'cn' ? 'cn' : 'en'),
        travel_dates: val('travel_dates'), trip_length: val('trip_length'), travelers: val('travelers'),
        interests: Object.keys(state.interests), hotel_style: val('hotel_style'), budget: val('budget'), message: val('message'),
        name: val('name'), email: val('email'), contact: val('contact'), lang: lang, page_url: location.href, submitted_at: new Date().toISOString(),
        utm_source: attr.utm_source, utm_medium: attr.utm_medium, utm_campaign: attr.utm_campaign, utm_term: attr.utm_term, utm_content: attr.utm_content, gclid: attr.gclid, fbclid: attr.fbclid, referrer: attr.referrer, landing_page: attr.landing_page
      };
      if (!p.name) { setStatus(t.req + ' ' + t.name); return; }
      if (!p.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.email)) { setStatus(t.badEmail); return; }
      busy = true; var orig = btn.textContent; btn.textContent = t.sending;
      mSend(p).then(function () {
        var card = document.createElement('div');
        card.style.cssText = 'background:#F2F8F4;border:1px solid #BFDFCB;border-radius:16px;padding:26px 22px;margin:8px 20px 30px';
        card.innerHTML = '<div style="font:700 19px/1.3 ' + SERF + ';color:#2E6E64">' + t.okTitle + '</div><div style="font:400 14px/1.7 ' + SANS + ';color:#4A423D;margin-top:8px">' + t.okBody + '</div>';
        form.parentNode.insertBefore(card, form); form.style.display = 'none'; card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }).catch(function (err) { busy = false; btn.textContent = orig; setStatus(t.err); try { console.warn('[LN_INQUIRY] mobile submit failed:', err); } catch (e) {} });
    });
  }

  return { enhance: enhance, renderMobile: renderMobile, wireMobile: wireMobile, applyIntent: applyIntent, CONFIG: CONFIG };
})();
